module.exports = __webpack_public_path__ + "img/brand-logo4.6c707332.png";